import * as React from "react";

import { useDispatch } from "react-redux";

import MuiButton from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import ActionClose from "@material-ui/icons/Close";
import ActionPrint from "@material-ui/icons/Print";
import DownloadIcon from "mdi-material-ui/Download";

import { showNotification } from "jazasoft";
import Table from "jazasoft/lib/mui/components/Table";

import { useDeepMemo, useMutation, useSetting } from "../../../hooks";
import { BundleSheetType, LayState } from "../../../constants";
import { DataType, getData, getHeader, printTickets } from "../feedbackHelper";
import { isEmpty } from "../../../utils/helpers";
import SettingKeys from "../../../utils/SettingKeys";

const LayDialog = props => {
  const { open, order, orderFlow, lay, deviationTypes, layMap, onClose, onRefresh, onPrint } = props;
  const orderId = order?.id;

  const dispatch = useDispatch();
  const [mutate, { loading: busy }] = useMutation();
  const [download, { loading: downloading }] = useMutation({ rawResponse: true });

  const ticketPageFormat = useSetting(SettingKeys.TICKET_PAGE_FORMAT);

  const onTicketPrint = ({ layNo }) => {
    if (isEmpty(order) || isEmpty(orderFlow)) return;

    const options = {
      url: `orders/${orderId}/bundles`,
      method: "get",
      params: { flowId: orderFlow.id, layNo, action: 'manual' }
    };
    mutate(options, {
      onSuccess: bundleSheet => {
        printTickets({ order, orderFlow, bundleSheet, layNo, format: ticketPageFormat });
        onClose && onClose();
      }
    });
  };

  const onBundleGenrate = () => {
    const options = {
      url: `orders/${orderId}/bundles`,
      method: "post",
      params: { flowId: orderFlow.id, layNo: lay.layNo, action: 'manual' }
    };
    mutate(options, {
      onSuccess: () => {
        dispatch(showNotification("Bundles generated successfully."));
        onRefresh && onRefresh();
        onClose && onClose();
      }
    });
  };

  const downloadBundles = layNo => {
    if (isEmpty(order) || isEmpty(orderFlow)) return;
    const options = {
      url: `orders/${order?.id}/bundles`,
      method: "get",
      headers: { Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" },
      params: { flowId: orderFlow.id, layNo: lay?.layNo, action: 'manual' },
      responseType: "arraybuffer"
    };

    download(options, {
      onSuccess: response => {
        const header = response.headers["content-disposition"];
        var filename = header ? header.match(/filename="(.+)"/)[1] : `BUNDLES.xlsx`;

        let blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      }
    });
  };

  const { columns, rows, title } = useDeepMemo(() => {
    let columns, rows, title;
    if (lay) {
      title = `Lay #${lay.layNo}`;
      columns = getHeader({ dataType: DataType.LAY });
      rows = getData({ dataType: DataType.LAY, lay, layMap });
      rows = rows.map(r => ({ ...r, deviation: deviationTypes[r.causeDeviation] }));
    }
    return { columns, rows, title };
  }, [lay, layMap]);

  return (
    <Dialog id="dialog-container" fullWidth={true} maxWidth={lay ? "xl" : "md"} open={open} onClose={onClose}>
      <DialogTitle id="dialog-title">{title}</DialogTitle>
      <Divider />
      <DialogContent id="dialog-content" style={{ padding: 0 }}>
        <Table columns={columns} rows={rows} emptyMessage={lay && "Feedback for rolls not filled yet"} />
      </DialogContent>
      {(!rows || rows.length === 0) && <Divider />}
      <DialogActions id="dialog-actions" style={{ padding: "1em" }}>
        <MuiButton onClick={onClose} color={"primary"} variant="outlined">
          <ActionClose style={{ marginRight: 4 }} />
          Close
        </MuiButton>
        {lay && lay.bundleGenerated && (
          <MuiButton onClick={() => onTicketPrint({ layNo: lay?.layNo })} color={"primary"} variant="outlined" disabled={busy}>
            <ActionPrint style={{ marginRight: 4 }} />
            Ticket
          </MuiButton>
        )}
        {lay && lay.bundleGenerated && (
          <MuiButton onClick={() => onPrint({ layNo: lay?.layNo, type: BundleSheetType.NORMAL })} color="primary" variant="outlined" disabled={busy}>
            <ActionPrint style={{ marginRight: 4 }} />
            Bundle Sheet
          </MuiButton>
        )}
        {lay && lay.bundleGenerated && (
          <MuiButton onClick={() => downloadBundles(lay?.layNo)} color="primary" variant="outlined" disabled={downloading}>
            <DownloadIcon style={{ marginRight: 4 }} />
            Download Bundles
          </MuiButton>
        )}
        {lay && lay.state === LayState.COMPLETED && !lay.bundleGenerated && (
          <MuiButton onClick={onBundleGenrate} color={"primary"} disabled={busy} variant="outlined">
            Generate Bundle
          </MuiButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default LayDialog;
